import React, { useEffect } from "react";
import { appModal, configureAppModal, offAppInteraction, onAppInteraction } from "../../../helpers/interactions";
import useModal from "../../../hooks/useModal";
import ErrorBoundary from "../ErrorBoundary";

export default function Modal() {
  const { title, body, visible, backdrop, large, hideModal, timestamp } = useModal();
  useEffect(() => {
    configureAppModal("#Modal", { backdrop });
    appModal("#Modal", visible ? "show" : "hide");
    onAppInteraction("#Modal", "hidden.bs.modal", () => hideModal());
    return () => offAppInteraction("#Modal", "hidden.bs.modal");
  }, [visible, backdrop, hideModal]);
  return (
    // A dialog with no accessible name is announced as just "dialog", so point
    // it at the title it already renders.
    <div
      id="Modal"
      className="modal fade modal-fade-in-scale-up"
      aria-hidden="true"
      aria-labelledby="Modal-title"
      role="dialog"
    >
      <div className={`modal-dialog ${large ? "modal-lg" : ""}`}>
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
            <h4 className="modal-title" id="Modal-title">
              {title}
            </h4>
          </div>
          <div className="modal-body" key={timestamp}>
            {/* Contain a failing body here: the modal shell has to stay mounted
                so Bootstrap can still dismiss it and remove its backdrop. */}
            <ErrorBoundary fallback={<p className="margin-bottom-0">This content could not be displayed.</p>}>
              {body}
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  );
}
